import { useState, useEffect } from "react";
import { Link as RouterLink, useParams, useNavigate, useLocation } from "react-router-dom";
import { Button, Container, Grid, Stack, Typography, TextField, Chip, Checkbox, Select, OutlinedInput, MenuItem, useTheme, FormControl, FormControlLabel, FormLabel, RadioGroup, Radio, Paper, Tabs, Tab, Box } from "@mui/material";
// components
import StringUtil from "src/utils/StringUtil";
import { alert } from "src/services/alert";
import { COMP_NAME } from "src/config/constants";
import FormItem from "src/components/form-item/FormItem";
import Uploader from "src/components/uploader/Uploader";
import { useSelector } from "react-redux";
import { asyncRequest } from "src/services/network";
import FormDialog from "src/components/common/FormDialog";

export default function CouponEdit({ open, item, onClose, onFinish }) {
  const categories = useSelector((state) => state.globalData.productCategories) || [];
  const navigate = useNavigate();
  const { id } = item;
  const [category, setCategory] = useState({});

  const [detail, setDetail] = useState(item.detail);

  // console.log('categories', categories)

  const [tabIdx, setTabIdx] = useState("0");

  const [form, setForm] = useState({
    name: item.name || "",
    cover: item.cover || "",
    category: item.category || 1,
    type: item.type || 1,
    reach: item.reach || "",
    deduction: item.deduction || "",
    isGeneral: item.isGeneral != undefined ? item.isGeneral : true,
    productIds: item.productIds || "",
    useTimes: item.useTimes || "",
    useTimeType: item.useTimeType || 1,
    stock: item.stock || "",
    order: item.order || 0,
    status: item.status || 1,
  });

  useEffect(() => {}, []);

  function handleIptChange(ki, val) {
    setForm({
      ...form,
      [ki]: val,
    });
  }

  async function handleSubmit() {
    const formData = {
      ...form,
      detail,
    };

    if (id) {
      formData.id = id;
    }

    const { data } = await asyncRequest({
      path: id ? "/coupon/edit" : "/coupon/add",
      data: formData,
    });

    onFinish();
  }

  return (
    <FormDialog open={open} title={`${id ? "编辑" : "添加"}商品`} onClose={onClose} onConfirm={handleSubmit}>
      {/* <FormItem title="类型" required>
        <RadioGroup row aria-label="gender" name="row-radio-buttons-group" value={form.category}>
          <FormControlLabel value={1} control={<Radio />} label="商城" onChange={(e) => handleIptChange("category", e.target.value)} />
        </RadioGroup>
      </FormItem> */}

      <FormItem title="名称" required>
        <TextField fullWidth placeholder="请输入名称" autoComplete="off" id="name" value={form.name} size="small" onChange={(e) => handleIptChange("name", e.target.value)} />
      </FormItem>

      <FormItem title="类型" required>
        <RadioGroup row aria-label="gender" name="row-radio-buttons-group" value={form.type}>
          <FormControlLabel value={1} control={<Radio />} label="洗车券" onChange={(e) => handleIptChange("type", e.target.value)} />
          <FormControlLabel value={2} control={<Radio />} label="油卡" onChange={(e) => handleIptChange("type", e.target.value)} />
          <FormControlLabel value={3} control={<Radio />} label="电卡" onChange={(e) => handleIptChange("type", e.target.value)} />
        </RadioGroup>
      </FormItem>

      {/* {form.type == 0 && (
        <FormItem title="消费规则" required>
          <Stack direction="row" alignItems="center" spacing={1}>
            <Typography>满</Typography>
            <TextField value={form.reach} autoComplete="off" sx={{ width: 100 }} size="small" onChange={(e) => handleIptChange("reach", e.target.value)} />
            <Typography>减</Typography>
            <TextField value={form.deduction} autoComplete="off" sx={{ width: 100 }} size="small" onChange={(e) => handleIptChange("deduction", e.target.value)} />
            <Typography>元</Typography>
          </Stack>
        </FormItem>
      )}

      {form.type == 1 && (
        <FormItem title="消费规则" required>
          <Stack direction="row" alignItems="center" spacing={1}>
            <Typography>满</Typography>
            <TextField value={form.reach} autoComplete="off" sx={{ width: 100 }} size="small" onChange={(e) => handleIptChange("reach", e.target.value)} />
            <Typography>减</Typography>
            <TextField value={form.discount} autoComplete="off" sx={{ width: 100 }} size="small" onChange={(e) => handleIptChange("discount", e.target.value)} />
            <Typography>折</Typography>
          </Stack>
        </FormItem>
      )} */}

      {form.type == 2 && (
        <FormItem title="消费规则" required>
          <Stack direction="row" alignItems="center" spacing={1}>
            <Typography>仅核销</Typography>
          </Stack>
        </FormItem>
      )}

      <FormItem title="适用范围" required>
        <RadioGroup row aria-label="gender" name="row-radio-buttons-group" value={form.isGeneral}>
          <FormControlLabel value={true} control={<Radio />} label="全场通用" onChange={(e) => handleIptChange("isGeneral", e.target.value)} />
          <FormControlLabel value={false} control={<Radio />} label="指定商品" onChange={(e) => handleIptChange("isGeneral", e.target.value)} />
        </RadioGroup>
      </FormItem>

      <FormItem title="卡券封面">
        <Uploader images={form.cover} onUploaded={(v) => handleIptChange("cover", v)} />
      </FormItem>

      <FormItem title="使用时间" required>
        <RadioGroup row aria-label="gender" name="row-radio-buttons-group" value={form.useTimeType}>
          <FormControlLabel value={1} control={<Radio />} label="天数" onChange={(e) => handleIptChange("useTimeType", e.target.value)} />
          <FormControlLabel value={2} control={<Radio />} label="指定时间段" onChange={(e) => handleIptChange("useTimeType", e.target.value)} />
        </RadioGroup>
      </FormItem>

      {form.useTimeType == 0 && (
        <FormItem title="使用天数" required>
          <TextField fullWidth placeholder="请输入使用天数" type="number" autoComplete="off" id="duration" value={form.duration} size="small" onChange={(e) => handleIptChange("duration", e.target.value)} />
        </FormItem>
      )}

      <FormItem title="库存" required>
        <TextField fullWidth placeholder="请输入库存" type="number" autoComplete="off" id="stock" value={form.stock} size="small" onChange={(e) => handleIptChange("stock", e.target.value)} />
      </FormItem>

      <FormItem title="排序" required>
        <TextField fullWidth placeholder="请输入排序" type="number" autoComplete="off" id="order" value={form.order} size="small" onChange={(e) => handleIptChange("order", e.target.value)} />
      </FormItem>
    </FormDialog>
  );
}
